import o from "axios";
const c = async (t, a) => {
  try {
    if (a) {
      const { data: e } = await o.post(
        `/api/checkout/pub/orderForm/${t}`
      );
      return e;
    }
    const { data: r } = await o.post("/api/proxy", {
      targetUrl: `/api/checkout/pub/orderForm/${t}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    });
    return r;
  } catch (r) {
    console.error("Error in Change Order Modal", r);
  }
};
export {
  c as getOrderForm
};
